import ApiTokenCard from './ApiTokenCard';

export default ApiTokenCard;